import React, { useState, useEffect } from 'react';
import { httpsCallable } from "firebase/functions";
import { functions } from '../firebase';
import EmailRegistrationCard from './EmailRegistrationCard';
import StravaClubCard from './StravaClubCard';

const PromoCard = ({ 
    user, 
    posthog, 
    onStravaConnect = null, 
    variant = 'default',
    style = {},
    onRewardClaimed = null
}) => {
    const [rewardStatus, setRewardStatus] = useState({
        email: { claimed: false },
        stravaClub: { claimed: false }
    });
    const [isLoading, setIsLoading] = useState(true);
    const [showEmailCard, setShowEmailCard] = useState(true);

    // Load reward status
    const loadRewardStatus = async () => {
        if (!user) {
            setIsLoading(false);
            return;
        }
        
        setIsLoading(true);
        try {
            const getCreditRewardStatusFunc = httpsCallable(functions, 'getCreditRewardStatus');
            const result = await getCreditRewardStatusFunc();
            
            setRewardStatus({
                email: result.data.email || { claimed: false },
                stravaClub: result.data.stravaClub || { claimed: false }
            });
            
            // Determine which card to show based on what's already claimed
            if (result.data.email?.claimed && !result.data.stravaClub?.claimed) {
                setShowEmailCard(false); // Show Strava card
            } else {
                setShowEmailCard(true); // Show email card (or nothing if both claimed)
            }
        } catch (error) {
            console.error("Error loading reward status:", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        loadRewardStatus();
    }, [user]);

    // Don't render if loading
    if (isLoading) {
        return null;
    }

    // If both rewards are claimed, show nothing
    if (rewardStatus.email.claimed && rewardStatus.stravaClub.claimed) {
        return null;
    }

    // If email not claimed, show email card
    if (!rewardStatus.email.claimed || showEmailCard) {
        return (
            <EmailRegistrationCard 
                user={user}
                posthog={posthog}
                onStravaConnect={onStravaConnect}
                variant={variant}
                style={style}
                onRewardClaimed={onRewardClaimed}
                alwaysVisible={false} // Use default behavior - hide if already claimed
            />
        );
    }

    // If email claimed but Strava not claimed, show Strava card
    if (rewardStatus.email.claimed && !rewardStatus.stravaClub.claimed) {
        // Only show Strava card if user is authenticated
        if (!user) {
            return null;
        }

        return (
            <div style={{ ...style, padding: 0 }}>
                <StravaClubCard 
                    user={user}
                    posthog={posthog}
                    onRewardClaimed={onRewardClaimed}
                    variant={variant}
                />
            </div>
        );
    }

    return null;
};

export default PromoCard;